import { ShieldCheck } from "lucide-react";
import { isNewCond } from "@/lib/store";

const chip = (on) => `rounded-full border px-3.5 py-2 text-sm transition-colors ${on ? "border-white bg-white text-black" : "border-white/15 text-zinc-200 hover:bg-white/10"}`;

// Garantia que aparece no site: a padrão (4 meses da loja no seminovo, 1 ano Apple no novo) ou a Apple até uma data.
export const WarrantyField = ({ form, setForm, input }) => {
  const apple = form.warranty_kind === "apple";
  const pick = (kind) => setForm((f) => ({ ...f, warranty_kind: kind }));
  return (
    <div data-testid="product-warranty-field">
      <span className="mb-1.5 flex items-center gap-1.5 text-xs text-zinc-400"><ShieldCheck className="h-3.5 w-3.5" /> Garantia que aparece no site</span>
      <div className="flex flex-wrap gap-2">
        <button type="button" data-testid="product-warranty-store" aria-pressed={!apple} onClick={() => pick("loja")} className={chip(!apple)}>
          {isNewCond(form.condition) ? "1 ano de garantia Apple" : "4 meses da loja"}
        </button>
        <button type="button" data-testid="product-warranty-apple" aria-pressed={apple} onClick={() => pick("apple")} className={chip(apple)}>Garantia Apple até uma data</button>
      </div>
      {apple && (
        <label className="mt-3 block">
          <span className="mb-1.5 block text-xs text-zinc-400">Garantia Apple até (Ajustes › Geral › Sobre › Cobertura)</span>
          <input data-testid="product-apple-warranty-input" type="date" value={form.apple_warranty_until}
            onChange={(e) => setForm((f) => ({ ...f, apple_warranty_until: e.target.value }))} className={input} />
        </label>
      )}
    </div>
  );
};
